import * as React from 'react'

function CellPhoneIcon(props) {
  return (
    <svg
      width='31'
      height='51'
      viewBox='0 0 31 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.2 0H2C0.89543 0 0 0.895429 0 2V48.3333C0 49.4379 0.895429 50.3333 2 50.3333H28.2C29.3046 50.3333 30.2 49.4379 30.2 48.3333V2C30.2 0.895431 29.3046 0 28.2 0Z'
        fill='#003D87'
      />
      <path
        d='M26.5217 1.67773H3.67725C2.57268 1.67773 1.67725 2.57317 1.67725 3.67774V40.2666H28.5217V3.67773C28.5217 2.57316 27.6263 1.67773 26.5217 1.67773Z'
        fill='white'
        stroke='#666666'
        strokeWidth='0.5'
      />
      <circle cx='15.1002' cy='45.2999' r='3.35556' fill='white' />
    </svg>
  )
}

export default CellPhoneIcon
